import React from 'react';

const Page500 = () => {
  return <div className="app flex-row align-items-center">500</div>;
};

export default Page500;
